<script>
  import { onDestroy } from "svelte";
  import Tooltip from "@components/Tooltip";
  import { notification } from "@stores/notification";

  const ERROR_TIMEOUT = 3000;

  let text = null;
  let timeout = null;

  $: if (text) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => {
      notification.set(null);
    }, ERROR_TIMEOUT);
  }

  const unsubscribe = notification.subscribe(message => {
    if (!message) {
      text = null;
      return;
    }

    text = message;
  });

  onDestroy(unsubscribe);
</script>

{#if text}
  <Tooltip notification={true} {text} />
{/if}
